"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LazyBurgerMenuContent = void 0;
var _react = require("react");
var _CataloguesSkeleton = require("../Catalogues/CataloguesSkeleton");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; } // istanbul ignore file -- lazy component render
const BurgerMenuContent = /*#__PURE__*/(0, _react.lazy)(async () => ({
  default: (await Promise.resolve().then(() => _interopRequireWildcard(require(/* webpackChunkName: "TopArea_BurgerMenuContent" */'./BurgerMenuContent')))).BurgerMenuContent
}));
const LazyBurgerMenuContent = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
  fallback: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CataloguesSkeleton.CataloguesSkeleton, {}),
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(BurgerMenuContent, {})
});
exports.LazyBurgerMenuContent = LazyBurgerMenuContent;
